import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';
import { ToastType } from './toast-type.constant';
import { SuccessToastIconComponent } from '../icons/success-toast-icon.component';
import { ErrorToastIconComponent } from '../icons/error-toast-icon.component';

/**
 * ToastContainerComponent
 *
 * Global container that renders active toast notifications.
 * Placed once in the root App component so toasts appear on every page.
 *
 * Toasts are positioned fixed at the top-right of the viewport
 * and stack vertically with smooth animations.
 *
 * Design matches the clean, simple style from the UI mockup with:
 * - Icon for success/error states
 * - Green background for success, red for error
 * - White text with title and description
 * - Close button
 * - Smooth slide-in animation
 */
@Component({
  selector: 'app-toast-container',
  imports: [SuccessToastIconComponent, ErrorToastIconComponent],
  templateUrl: './toast-container.html',
  styleUrl: './toast-container.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  protected readonly toastService = inject(ToastService);

  /** Expose ToastType constants for template usage */
  protected readonly ToastType = ToastType;
}
